import {useCallback, useState} from "react";

const BasicGuestFields = [
    {
        key: "first_name",
        required: true,
        type: "text"
    },
    {
        key: "last_name",
        required: true,
        type: "text"
    },
    {
        key: "email",
        required: false,
        type: "text"
    },
    {
        key: "nationality",
        required: false,
        type: "dropdown"
    }
];

const GuestFields = [
    {
        key: "salutation",
        required: false,
        type: "radio"
    },
    {
        key: "first_name",
        required: true,
        type: "text"
    },
    {
        key: "last_name",
        required: true,
        type: "text"
    },
    {
        key: "date_of_birth",
        required: true,
        type: "datetime"
    },
    {
        key: "nationality",
        required: false,
        type: "dropdown"
    },
    // TODO: Enable this when identification is on scope
    // {
    //     key: "identification",
    //     required: false,
    //     type: "radio"
    // },
    // {
    //     key: "identification_number",
    //     required: false,
    //     type: "text"
    // },
    {
        key: "street",
        required: false,
        type: "text"
    },
    {
        key: "city",
        required: false,
        type: "text"
    },
    {
        key: "zip_code",
        required: false,
        type: "text"
    },
    {
        key: "country",
        required: false,
        type: "text"
    },
];

const MainGuestExtraFields = [
    {
        key: "email",
        required: false,
        type: "text"
    },
    // TODO: Enable this when car_registration_number is on scope
    // {
    //     key: "car_registration_number",
    //     required: false,
    //     type: "text"
    // },
    {
        key: "phone",
        required: false,
        type: "text"
    },
    {
        key: "mobile",
        required: false,
        type: "text"
    },
];

export const useGuestFormFields = () => {
    const [basicGuestFields] = useState(BasicGuestFields);
    const [guestFields] = useState(GuestFields);
    const [mainGuestFields] = useState(MainGuestExtraFields);

    // TODO: Fetch the fields from external resource
    // For now we keep the fields hardcoded
    const getGuestMissingFields = useCallback((guest, excludedFields, isMainGuest = false, basicFieldsOnly = false) => {
        const missingFields = [];

        if (!guest || !guest?.is_editable) {
            return missingFields;
        }

        const fields = basicFieldsOnly ? basicGuestFields : (((guest?.main_guest) || isMainGuest) ? [...guestFields, ...mainGuestFields] : guestFields);

        for (const field of fields) {

            if (excludedFields?.includes(field?.key)) {
                continue;
            }
            if (
                (!guest[field?.key] && ("address" in guest && !guest?.address[field?.key])) ||
                (field.key === "salutation" && guest[field.key] === "other")
            ) {
                missingFields.push(field);
            }
        }
        return missingFields;
    }, [guestFields, mainGuestFields]);

    return {
        getGuestMissingFields
    };
};
